import React, { useState } from 'react';
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import { useLocation, useNavigate } from 'react-router';
import { EMPLOYEE_HELPDESK_COMMENTS, RAISE_REQUEST_PATH } from '../../../utils/Constants';
import pdfFIleIcon from '../../../asset/svg/pdfFile.svg'
import '../../../scss/pages/Employee helpdesk/ViewImagePage/ViewImagePage.scss'
import { Document, Page, pdfjs } from 'react-pdf';
import { useSelector } from 'react-redux';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function ViewImagePage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { TicketData } = useSelector(mapStateToProps)
    const { pdf, images } = location?.state;
    const [numPagess, setNumPages] = useState(1);

    const handleBack = () => {
        navigate(EMPLOYEE_HELPDESK_COMMENTS, { state: { ticketNo: TicketData } })
    }




    const onDocumentLoadSuccess = (e) => {
        const { numPages } = e._pdfInfo;
        setNumPages(numPages)
        setDisableBtn(false)
    }

    const renderFile = (pdf, images) => {
        if (pdf?.attachmentType === "application/pdf") {
            return (
                <Document file={pdf?.attachmentUrl} onLoadSuccess={(e) => onDocumentLoadSuccess(e)} >
                    {Array.from(new Array(numPagess), (el, index) => (
                        <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                </Document>
            )
        } else {
            return (
                <>
                    {images?.map((item) => {
                        return (
                            <div key={item?.id} className='ViewImagePage-Modal-Container_Document-image_child_image'>
                                <img src={item?.attachmentUrl} alt='img' />
                            </div>
                        )
                    })}
                </>)
        }
    }

    return (
        <div className='ViewImagePage-Modal-Container'>
            <div className='ViewImagePage-Modal-Container_header'>
                <div>
                    <img className='ViewImagePage-Modal-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='ViewImagePage-Modal-Container_header_content'>Preview</span>
                </div>
            </div>
            <div className='ViewImagePage-Modal-Container_Document-image'>
                <div id='pdfcontainer' className='ViewImagePage-Modal-Container_Document-image_child'>
                    {renderFile(pdf, images)}
                </div>
            </div>

        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        TicketData: state?.employeeHelpdesk?.TicketData
    }
}

export default ViewImagePage;